















import Component, { mixins } from 'vue-class-component';

import FormBase from '@/general/abstract/form/FormBase.vue';
import { VModel } from 'vue-property-decorator';
import WorkPeriodTemplateFormTemplate
  from '@/context/work_period/component/template-form/WorkPeriodTemplateFormTemplate.vue';
import WorkPeriodRouter from '@/context/work_period/router/WorkPeriodTemplateRouter';
import SimpleForm from '@/general/abstract/form/mixin/SimpleForm';

import AssignWorkPeriodFormTemplate
  from '@/context/work_period/component/assign-form/AssignWorkPeriodFormTemplate.vue';
import { AssignWorkPeriod } from '@/context/work_period/model/AssignWorkPeriod';
import { WorkPeriodApi } from '@/context/work_period/api/WorkPeriodApi';

@Component({
  components: {
    AssignWorkPeriodFormTemplate,
    WorkPeriodTemplateFormTemplate,
    FormBase
  }
})
export default class WorkPeriodTemplateForm extends mixins<SimpleForm<AssignWorkPeriod>>(
  SimpleForm
) {
  @VModel({ default: new AssignWorkPeriod() }) model!: AssignWorkPeriod;

  buildCmd(): AssignWorkPeriod {
    if (this?.model?.id) {
      return this.model;
    }
    let command: AssignWorkPeriod = Object.assign<AssignWorkPeriod, AssignWorkPeriod>(
      new AssignWorkPeriod(),
      this.model
    );
    return command;
  }

  async submitApi(cmd: AssignWorkPeriod): Promise<AssignWorkPeriod> {
    const model: AssignWorkPeriod = await WorkPeriodApi.instance().assign(cmd);
    return model;
  }

  showRoute(id: number): Record<string, unknown> {
    return WorkPeriodRouter.instance().list();
  }
}
